import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ProfileEdit from './ProfileProgressEditProfile'
import ProfileAddPlant from "./ProfileProgressAddPlant"
import ProfileInstall from "./ProfileProgressInstall"
import ProfileComplete from "./ProfileProgressComplete"
import { Link, useNavigate } from "react-router-dom";




function ProgressSteps(){
  const [activeStep, setActiveStep] = useState(0);
  let navigate = useNavigate()


  const nextStep = () => {
    if(activeStep < 3){
    setActiveStep((currentStep) => currentStep + 1)}
    else{
      navigate('/home')
    }
  }

  const previousStep = () => {
    if(activeStep !== 0){
    setActiveStep((currentStep) => currentStep - 1)}
  }

  const signedIn = (e) => {
    e.preventDefault();
  
  }

  
 

  let StepInformation = () => {
    switch (activeStep) {
      case 0:
        return (
          <>
            <div style={{paddingTop:"60px", paddingBottom:"60px"}}>
            <ProfileEdit />
            </div>
          </>
        );
        break;

      case 1:
        return (
          <>
          <div style={{paddingTop:"60px", paddingBottom:"60px"}}>
            <ProfileAddPlant />
          </div>
          </>
        );
        break;

      case 2:
        return (
          <>
          <div style={{paddingTop:"60px", paddingBottom:"60px"}}>
            <ProfileInstall />
          </div>
          </>
        );
        break;

        case 3:
        return (
          <>
            <ProfileComplete />
          </>
        );
        break;
    }
  };


  return (
  <div>
    <Stepper activeStep={activeStep}>
      <Step>
        <StepLabel>Edit Profile</StepLabel>
      </Step>

      <Step>
        <StepLabel >Add Plant</StepLabel>
      </Step>

      <Step>
        <StepLabel>Install Battery</StepLabel>
      </Step>
    </Stepper>




<div>{StepInformation()}</div>
{activeStep > 0 ?<button className="btn2 btn-default" onClick={()=> previousStep()} style={{marginRight:"20px"}} >Previous</button>:""}
 {activeStep > 2 ? <button className="btn2 btn-default" onClick={()=> nextStep()}  style={{marginRight:"20px"}}>Finish </button>: <button className="btn2 btn-default" onClick={()=> nextStep()}  style={{marginRight:"20px"}}>Next</button>}
   




{activeStep === 2 ?  <button className="btn2 btn-default" onClick={()=> nextStep()} style={{marginRight:"20px"}} >Skip</button> : ''}


  {/* 
    <Button variant='outlined' onClick={()=> nextStep()} >{activeStep > 2 ? 'Finish' : 'Next'}</Button> 
   
    {activeStep === 3 ? "" :  <Button variant='outlined' onClick={()=> previousStep()}>Previous Step</Button>}

    {activeStep === 2 ?  <Button variant='outlined' onClick={()=> nextStep()}>Skip</Button> : ''}
   */}
  </div>
  )
}


export default ProgressSteps
